import { useState, useRef } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import TabE from './TabE';
import TabF from './TabF';

export default function E_TAB() {
    const { t } = useLang('outdoorrecreation');
    const [activeTab, setActiveTab] = useState(0);
    const pillRefs = useRef<(HTMLButtonElement | null)[]>([]);

    const handleTabClick = (index: number) => {
        setActiveTab(index);
        pillRefs.current[index]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });
    };

    return (
        <div className={`outdoor-recreation-TAB ${css['outdoor-recreation-TAB']}`}>
            <div className="inner tab-bar">
                <div className="tabs-bar-inner">
                    <button
                        ref={(el) => {
                            pillRefs.current[0] = el;
                        }}
                        className={`tab-pill${activeTab === 0 ? ' active' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        {t('secE_title')}
                    </button>
                    <button
                        ref={(el) => {
                            pillRefs.current[1] = el;
                        }}
                        className={`tab-pill${activeTab === 1 ? ' active' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        {t('secF_title')}
                    </button>
                </div>
            </div>
            <div className={`tab-panel${activeTab === 0 ? ' visible' : ''}`}>
                <TabE />
            </div>
            <div className={`tab-panel${activeTab === 1 ? ' visible' : ''}`}>
                <TabF />
            </div>
        </div>
    );
}
